import hyperdom from 'hyperdom'
import renderDuration from '../../../packages/dates/renderDuration.js'
import responsiveRender from './responsiveRender.js'
import FeefoRating from './feefoRating.jsx'

export default class TourHeader {
  constructor ({getDetails, modals, config, tourCode, tripDetails, feefoRating}) {
    this.getDetails = getDetails
    this.modals = modals
    this.config = config
    this.tourCode = tourCode
    this.tripDetails = tripDetails
    this.feefoRating = feefoRating
  }

  render (mode) {
    this.details = this.getDetails()
    return mode === 'compact' ? this.renderCompact() : this.renderNormal()
  }

  renderCompact () {
    const {details} = this
    return <div class='tour-header'>
      <div class='tour-header__wrapper'>
        {
          details.photoInlineStyles ?
            <div class="tour-header__photo" style={details.photoInlineStyles}></div>
            : undefined
        }
        <div class='tour-header__headings'>
          <h3 class='tour-header__name'>{details.tourName}</h3>
          <div class='tour-header__middle-info'>
            <div class='tour-header__rating'>
              {this.renderProductRating()}
            </div>
          </div>
          {this.renderTourHeaderBottom('tour-header__bottom-info')}
        </div>
      </div>
      {this.renderTourHeaderBottom('tour-header__bottom-info-mobile')}
    </div>
  }

  renderTourHeaderBottom (wrapperClass) {
    const {details} = this
    return <div class={wrapperClass}>
      <div class='tour-header__duration'>
        {renderDuration(details.startDate , details.endDate)}
      </div>
      {
        !this.config.hideItineraryMap ?
          <div class="booking-summary-itinerary-map-modal__button" onclick={e => {e.preventDefault(); return this.tripDetails.showReviewTripDetails(details.mapUrl)}}>
            <span class="booking-summary-itinerary-map-modal__button__label">View Itinerary &amp; Map</span>
            <i class="-new-ui_maximize"/>
          </div>
          :null
      }
    </div>
  }

  renderProductRating () {
    if (!this.config.features.showRating) {
      return
    }

    return this.feefoRating ? this.feefoRating : FeefoRating.renderRating(5, false, true)
  }

  renderNormal () {
    return <div>
      <div class="tour-header-confirmation__section-title">About your trip</div>
      {responsiveRender('small',
        () => this.renderSmallDeviceLayout(),
        () => this.renderRegularLayout()
      )}
    </div>
  }

  renderRegularLayout () {
    const {details} = this
    return <div class="tour-header-confirmation">
      <div class="tour-header-confirmation__details-section">
        <div class="tour-header-confirmation__header u-padding-medium">
          <div class="tour-header-confirmation__image">{this.renderHeaderImage(details.imageUrl, true)}</div>
          <div class="tour-header-confirmation__departure-info u-margin-left-large">
            <h3 class='tour-header__name u-margin-bottom-small'>{details.tourName}</h3>
            <div class='tour-header__middle-info'>
              {this.renderProductRating()}
            </div>
          </div>
        </div>
        <div class="tour-header-confirmation__details u-padding-left-medium  u-padding-bottom-small">
          {this.renderDetail('days')}
          {this.renderDetail('countries')}
          {this.renderDetail('passengers')}
        </div>
      </div>
      <div class="tour-header__map">{this.renderHeaderImage(details.mapUrl)}</div>
    </div>
  }

  renderSmallDeviceLayout () {
    const {details} = this
    return <div class="tour-header-confirmation">
      <div class="tour-header-confirmation__image">{this.renderHeaderImage(details.imageUrl)}</div>
      <div class="tour-header-confirmation__details-section u-padding-left-medium u-padding-right-medium u-padding-bottom-large u-padding-top-large">
        <div class="tour-header-confirmation__title">{details.tourName}</div>
        <div class="u-margin-bottom-medium">{this.renderProductRating()}</div>
        <div class="tour-header-confirmation__details-row">
          {this.renderDetail('days')}
          {this.renderDetail('countries')}
        </div>
        {this.renderDetail('passengers')}
      </div>
      <div class="tour-header__map">{this.renderHeaderImage(details.mapUrl)}</div>
    </div>
  }

  renderDetail (propertyName) {
    const {details} = this
    return <div class="tour-header-confirmation__detail-container">
      <div class={`tour-header-confirmation__${propertyName}-header`}>{propertyName}</div>
      <div class={`tour-header-confirmation__${propertyName}-detail`}>{details[propertyName]}</div>
    </div>
  }

  renderHeaderImage (url, rounded) {
    return <img class={{'tour-header__image-rounded': rounded === true}} src={url} />
  }
}
